import React, { useEffect, useMemo, useState } from "react";
import { useTable, useFilters, useSortBy } from "react-table";

import api, { handleApi } from "pages/api/api";
import { useAlert } from "pages/context/AlertContext";
import { useAuth } from "pages/context/AuthContext";
import PageHeader from "pages/components/PageHeader";
import Draggable from "react-draggable";
import Paper from "@mui/material/Paper";

import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";

import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import MDInput from "components/MDInput";

import Card from "@mui/material/Card";
import CircularProgress from "@mui/material/CircularProgress";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";

import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import InfoIcon from "@mui/icons-material/Info";
import PaymentsIcon from "@mui/icons-material/Payments";

function PaperComponent(props) {
  return (
    <Draggable handle="#draggable-dialog-title" cancel={'[class*="MuiDialogContent-root"]'}>
      <Paper {...props} />
    </Draggable>
  );
}

function TextFilter({ column: { filterValue, setFilter } }) {
  return (
    <input
      value={filterValue || ""}
      onChange={(e) => setFilter(e.target.value || undefined)}
      placeholder="filtrar..."
      style={{
        width: "100%",
        padding: "6px 4px",
        border: "none",
        borderBottom: "1px solid rgba(0,0,0,0.2)",
        outline: "none",
        background: "transparent",
        fontSize: 12,
        color: "#556",
      }}
    />
  );
}

const FILTERS_KEY = "tbl:campanhas:filters";
const KEEP_KEY = "tbl:campanhas:keep";

const materialLabel = (m) => (m?.nome ? `${m.nome} (${m.ref})` : "");

export default function Campanhas() {
  const { showAlert } = useAlert();
  const { temPermissao, userData } = useAuth();

  const [loading, setLoading] = useState(false);

  const [data, setData] = useState([]);
  const [fabricantes, setFabricantes] = useState([]);
  const [contactos, setContactos] = useState([]);
  const [materiaisCombo, setMateriaisCombo] = useState([]);

  const [fabricanteInput, setFabricanteInput] = useState("");
  const [materialInput, setMaterialInput] = useState("");
  const [alternativaInput, setAlternativaInput] = useState("");
  const [alternativaGeralInput, setAlternativaGeralInput] = useState("");
  const [ofertaInput, setOfertaInput] = useState("");

  const [materiaisCampanha, setMateriaisCampanha] = useState([]);
  const [alternativasPorMaterial, setAlternativasPorMaterial] = useState({});
  const [alternativasGerais, setAlternativasGerais] = useState([]);
  const [beneficios, setBeneficios] = useState([]);
  const [resultados, setResultados] = useState([]);

  const [openDialog, setOpenDialog] = useState(false);
  const [editando, setEditando] = useState(false);

  const [openDialogMaterial, setOpenDialogMaterial] = useState(false);
  const [openDialogAlternativas, setOpenDialogAlternativas] = useState(false);
  const [materialAlternativasSelecionado, setMaterialAlternativasSelecionado] = useState(null);

  const [openConfirmDelMaterial, setOpenConfirmDelMaterial] = useState(false);
  const [materialParaEliminar, setMaterialParaEliminar] = useState(null);

  const [openResultado, setOpenResultado] = useState(false);
  const [resultadoSelecionado, setResultadoSelecionado] = useState(null);
  const [resultadoLinhas, setResultadoLinhas] = useState([]);
  const [resultadoBeneficios, setResultadoBeneficios] = useState([]);
  const [resultadoRecebimentos, setResultadoRecebimentos] = useState([]);

  const [openRecebimentos, setOpenRecebimentos] = useState(false);
  const [recebimentosLinhas, setRecebimentosLinhas] = useState([]);
  const [historicoRecebimentosCampanha, setHistoricoRecebimentosCampanha] = useState([]);

  const [openConfirmValidar, setOpenConfirmValidar] = useState(false);
  const [resultadoValidar, setResultadoValidar] = useState(null);

  const [openResultadosCampanha, setOpenResultadosCampanha] = useState(false);
  const [campanhaResultados, setCampanhaResultados] = useState(null);

  const [form, setForm] = useState({
    id: null,
    nome: "",
    codigo_campanha: "",
    reffabricante: "",
    idfabricantecontacto: "",
    datainicial: "",
    datafinal: "",
    enviaremail: 0,
    obs: "",
  });

  const [formMaterial, setFormMaterial] = useState({
    id: null,
    refmaterial: "",
    qtd: 1,
    unidade: "",
    obs: "",
  });

  const [formAlternativa, setFormAlternativa] = useState({
    id: null,
    idcampanhamaterial: null,
    refmaterialalternativo: "",
    qtd: 1,
    unidade: "",
    obs: "",
  });

  const [formAlternativaGeral, setFormAlternativaGeral] = useState({
    id: null,
    refmaterialalternativo: "",
    qtd: 1,
    unidade: "",
    obs: "",
  });

  const [formBeneficio, setFormBeneficio] = useState({
    id: null,
    tipobeneficio: "VALOR_FIXO",
    basecalculo: "CONJUNTO",
    valor_eur: "",
    valor_por_unidade: "",
    percentagem: "",
    usar_iec: 0,
    refmaterialgrupo_iec: "",
    refmaterialoferta: "",
    qtdoferta: "",
    unidadeoferta: "",
    aplicaporconjunto: 1,
    limitevalor_eur: "",
    obs: "",
  });

  const [recebimentosForm, setRecebimentosForm] = useState({
    datarecebimento: new Date().toISOString().substring(0, 10),
    docref: "",
    obs: "",
  });

  const initialKeep = (() => {
    try {
      const v = localStorage.getItem(KEEP_KEY);
      return v === null ? true : JSON.parse(v);
    } catch {
      return true;
    }
  })();

  const [keepFilters, setKeepFilters] = useState(initialKeep);

  const initialFilters = keepFilters
    ? (() => {
        try {
          return JSON.parse(localStorage.getItem(FILTERS_KEY) || "[]");
        } catch {
          return [];
        }
      })()
    : [];

  const carregar = async () => {
    setLoading(true);
    const [payload, err] = await handleApi(
      api.post("Campanhas/SelCampanhas", { mostrarExpiradas: 1 })
    );
    setLoading(false);

    if (err) {
      showAlert(err, "error");
      return;
    }

    setData(Array.isArray(payload) ? payload : []);
  };

  const carregarMateriaisCombo = async (term = "") => {
    const [payload, err] = await handleApi(
      api.post("Campanhas/SelMateriaisCampanhasCombo", { term })
    );

    if (err) {
      showAlert(err, "error");
      return;
    }

    setMateriaisCombo(Array.isArray(payload) ? payload : []);
  };

  const carregarFabricantes = async (term = "") => {
    const [payload, err] = await handleApi(
      api.post("Campanhas/SelFabricantesCampanhasCombo", { term })
    );

    if (err) {
      showAlert(err, "error");
      return;
    }

    setFabricantes(Array.isArray(payload) ? payload : []);
  };

  const carregarContactos = async (reffabricante) => {
    if (!reffabricante) {
      setContactos([]);
      return;
    }

    const [payload, err] = await handleApi(
      api.post("Campanhas/SelFabricantesContactos", { reffabricante })
    );

    if (err) {
      showAlert(err, "error");
      return;
    }

    setContactos(Array.isArray(payload) ? payload : []);
  };

  const carregarMateriaisCampanha = async (idcampanha) => {
    if (!idcampanha) {
      setMateriaisCampanha([]);
      return;
    }

    const [payload, err] = await handleApi(
      api.post("Campanhas/SelCampanhasMateriais", { idcampanha })
    );

    if (err) {
      showAlert(err, "error");
      return;
    }

    const lista = Array.isArray(payload) ? payload : [];
    setMateriaisCampanha(lista);

    const paresAlternativas = await Promise.all(
      lista.map(async (m) => {
        const [alts, altErr] = await handleApi(
          api.post("Campanhas/SelCampanhasMateriaisAlternativos", {
            idcampanhamaterial: m.id,
          })
        );

        return [m.id, altErr ? [] : Array.isArray(alts) ? alts : []];
      })
    );

    setAlternativasPorMaterial(Object.fromEntries(paresAlternativas));
  };

  const carregarAlternativasMaterial = async (idcampanhamaterial) => {
    if (!idcampanhamaterial) return;

    const [payload, err] = await handleApi(
      api.post("Campanhas/SelCampanhasMateriaisAlternativos", { idcampanhamaterial })
    );

    if (err) {
      showAlert(err, "error");
      return;
    }

    setAlternativasPorMaterial((p) => ({
      ...p,
      [idcampanhamaterial]: Array.isArray(payload) ? payload : [],
    }));
  };

  const carregarAlternativasGerais = async (idcampanha) => {
    if (!idcampanha) {
      setAlternativasGerais([]);
      return;
    }

    const [payload, err] = await handleApi(
      api.post("Campanhas/SelCampanhasMateriaisAlternativosGerais", { idcampanha })
    );

    if (err) {
      showAlert(err, "error");
      return;
    }

    setAlternativasGerais(Array.isArray(payload) ? payload : []);
  };

  const carregarBeneficios = async (idcampanha) => {
    if (!idcampanha) {
      setBeneficios([]);
      return;
    }

    const [payload, err] = await handleApi(
      api.post("Campanhas/SelCampanhasBeneficios", { idcampanha })
    );

    if (err) {
      showAlert(err, "error");
      return;
    }

    setBeneficios(Array.isArray(payload) ? payload : []);
  };

  const carregarResultados = async (idcampanha) => {
    if (!idcampanha) {
      setResultados([]);
      return;
    }

    const [payload, err] = await handleApi(
      api.post("Campanhas/SelCampanhasFaturas", { idcampanha })
    );

    if (err) {
      showAlert(err, "error");
      return;
    }

    setResultados(Array.isArray(payload) ? payload : []);
  };

  useEffect(() => {
    carregar();
    carregarFabricantes();
    carregarMateriaisCombo();
  }, []);

  const limparDetalhesCampanha = () => {
    setContactos([]);
    setMateriaisCampanha([]);
    setAlternativasGerais([]);
    setBeneficios([]);
    setOfertaInput("");
    setResultados([]);
    setAlternativasPorMaterial({});
    setResultadoRecebimentos([]);
  };

  const handleOpenNovo = () => {
    setEditando(false);
    limparDetalhesCampanha();
    setFabricanteInput("");

    setFormBeneficio({
      id: null,
      tipobeneficio: "VALOR_FIXO",
      basecalculo: "CONJUNTO",
      valor_eur: "",
      valor_por_unidade: "",
      percentagem: "",
      usar_iec: 0,
      refmaterialgrupo_iec: "",
      refmaterialoferta: "",
      qtdoferta: "",
      unidadeoferta: "",
      aplicaporconjunto: 1,
      limitevalor_eur: "",
      obs: "",
    });

    setForm({
      id: null,
      nome: "",
      codigo_campanha: "",
      reffabricante: "",
      idfabricantecontacto: "",
      datainicial: "",
      datafinal: "",
      enviaremail: 0,
      obs: "",
    });

    setFormAlternativaGeral({
      id: null,
      refmaterialalternativo: "",
      qtd: 1,
      unidade: "",
      obs: "",
    });

    setMaterialInput("");
    setAlternativaInput("");
    setAlternativaGeralInput("");

    setOpenDialog(true);
  };

  const handleOpenEditar = async (row) => {
    setEditando(true);
    setLoading(true);

    const [payload, err] = await handleApi(api.post("Campanhas/SelCampanha", { id: row.id }));
    setLoading(false);

    if (err) {
      showAlert(err, "error");
      return;
    }

    await carregarContactos(payload.reffabricante);
    await carregarMateriaisCampanha(payload.id);
    await carregarAlternativasGerais(payload.id);
    await carregarBeneficios(payload.id);
    await carregarResultados(payload.id);

    setForm({
      id: payload.id,
      nome: payload.nome || "",
      codigo_campanha: payload.codigo_campanha || "",
      reffabricante: payload.reffabricante || "",
      idfabricantecontacto: payload.idfabricantecontacto || "",
      datainicial: payload.datainicial ? String(payload.datainicial).substring(0, 10) : "",
      datafinal: payload.datafinal ? String(payload.datafinal).substring(0, 10) : "",
      enviaremail: payload.enviaremail === 1 ? 1 : 0,
      obs: payload.obs || "",
    });

    setFabricanteInput(
      payload.fabricante ? `${payload.fabricante} (${payload.reffabricante})` : ""
    );

    setFormBeneficio({
      id: null,
      tipobeneficio: "VALOR_FIXO",
      basecalculo: "CONJUNTO",
      valor_eur: "",
      valor_por_unidade: "",
      percentagem: "",
      usar_iec: 0,
      refmaterialgrupo_iec: "",
      refmaterialoferta: "",
      qtdoferta: "",
      unidadeoferta: "",
      aplicaporconjunto: 1,
      limitevalor_eur: "",
      obs: "",
    });

    setFormAlternativaGeral({
      id: null,
      refmaterialalternativo: "",
      qtd: 1,
      unidade: "",
      obs: "",
    });

    setOfertaInput("");
    setMaterialInput("");
    setAlternativaInput("");
    setAlternativaGeralInput("");

    setOpenDialog(true);
  };

  const guardar = async () => {
    if (!form.nome || !form.reffabricante || !form.datainicial || !form.datafinal) {
      showAlert("Preenche nome, fabricante e datas.", "warning");
      return;
    }

    setLoading(true);

    const body = {
      ...form,
      idfabricantecontacto: form.idfabricantecontacto || null,
      criado_por: userData?.id || null,
      atualizado_por: userData?.id || null,
    };

    const endpoint = editando ? "Campanhas/UpdCampanha" : "Campanhas/InsCampanha";
    const [_, err, meta] = await handleApi(api.post(endpoint, body));

    setLoading(false);

    if (err) {
      showAlert(err, "error");
      return;
    }

    showAlert(meta?.message || "Gravado com sucesso.", meta?.severity || "success");
    setOpenDialog(false);
    await carregar();
  };

  const abrirNovoMaterial = () => {
    setFormMaterial({
      id: null,
      refmaterial: "",
      qtd: 1,
      unidade: "",
      obs: "",
    });
    setMaterialInput("");
    setOpenDialogMaterial(true);
  };

  const abrirEditarMaterial = (m) => {
    setFormMaterial({
      id: m.id,
      refmaterial: m.refmaterial || "",
      qtd: m.qtd || 1,
      unidade: m.unidade || "",
      obs: m.obs || "",
    });

    setMaterialInput(m.material ? `${m.material} (${m.refmaterial})` : "");
    setOpenDialogMaterial(true);
  };

  const fecharDialogMaterial = () => {
    setOpenDialogMaterial(false);
    setMaterialInput("");
    setFormMaterial({
      id: null,
      refmaterial: "",
      qtd: 1,
      unidade: "",
      obs: "",
    });
  };

  const guardarMaterial = async () => {
    if (!form.id) {
      showAlert("Grava primeiro o cabeçalho da campanha.", "warning");
      return;
    }

    if (!formMaterial.refmaterial || Number(formMaterial.qtd) <= 0) {
      showAlert("Indica material e quantidade.", "warning");
      return;
    }

    setLoading(true);

    const body = {
      id: formMaterial.id,
      idcampanha: form.id,
      refmaterial: formMaterial.refmaterial,
      qtd: Number(formMaterial.qtd),
      unidade: formMaterial.unidade,
      obs: formMaterial.obs,
    };

    const endpoint = formMaterial.id
      ? "Campanhas/UpdCampanhaMaterial"
      : "Campanhas/InsCampanhaMaterial";

    const [_, err, meta] = await handleApi(api.post(endpoint, body));

    setLoading(false);

    if (err) {
      showAlert(err, "error");
      return;
    }

    showAlert(meta?.message || "Material gravado.", meta?.severity || "success");

    fecharDialogMaterial();
    await carregarMateriaisCampanha(form.id);
  };

  const pedirEliminarMaterial = (m) => {
    setMaterialParaEliminar(m);
    setOpenConfirmDelMaterial(true);
  };

  const fecharConfirmDelMaterial = () => {
    setOpenConfirmDelMaterial(false);
    setMaterialParaEliminar(null);
  };

  const confirmarEliminarMaterial = async () => {
    if (!materialParaEliminar?.id) return;

    setLoading(true);

    const [_, err, meta] = await handleApi(
      api.post("Campanhas/DelCampanhaMaterial", { id: materialParaEliminar.id })
    );

    setLoading(false);

    if (err) {
      showAlert(err, "error");
      return;
    }

    showAlert(meta?.message || "Material eliminado.", meta?.severity || "success");

    fecharConfirmDelMaterial();
    await carregarMateriaisCampanha(form.id);
  };

  const abrirAlternativas = async (m) => {
    setMaterialAlternativasSelecionado(m);
    setFormAlternativa({
      id: null,
      idcampanhamaterial: m.id,
      refmaterialalternativo: "",
      qtd: m.qtd || 1,
      unidade: m.unidade || "",
      obs: "",
    });
    setAlternativaInput("");
    setOpenDialogAlternativas(true);
    await carregarAlternativasMaterial(m.id);
  };

  const fecharDialogAlternativas = () => {
    setOpenDialogAlternativas(false);
    setMaterialAlternativasSelecionado(null);
    setAlternativaInput("");
    setFormAlternativa({
      id: null,
      idcampanhamaterial: null,
      refmaterialalternativo: "",
      qtd: 1,
      unidade: "",
      obs: "",
    });
  };

  const abrirEditarAlternativa = (material, alternativa) => {
    setMaterialAlternativasSelecionado(material);

    setFormAlternativa({
      id: alternativa.id,
      idcampanhamaterial: alternativa.idcampanhamaterial,
      refmaterialalternativo: alternativa.refmaterialalternativo || "",
      qtd: alternativa.qtd || 1,
      unidade: alternativa.unidade || "",
      obs: alternativa.obs || "",
    });

    setAlternativaInput(
      alternativa.materialalternativo
        ? `${alternativa.materialalternativo} (${alternativa.refmaterialalternativo})`
        : ""
    );

    setOpenDialogAlternativas(true);
  };

  const guardarAlternativa = async () => {
    if (!formAlternativa.idcampanhamaterial) {
      showAlert("Seleciona primeiro o material principal.", "warning");
      return;
    }

    if (!formAlternativa.refmaterialalternativo || Number(formAlternativa.qtd) <= 0) {
      showAlert("Indica material alternativo e quantidade.", "warning");
      return;
    }

    setLoading(true);

    const body = {
      id: formAlternativa.id,
      idcampanhamaterial: formAlternativa.idcampanhamaterial,
      refmaterialalternativo: formAlternativa.refmaterialalternativo,
      qtd: Number(formAlternativa.qtd),
      unidade: formAlternativa.unidade,
      obs: formAlternativa.obs,
    };

    const endpoint = formAlternativa.id
      ? "Campanhas/UpdCampanhaMaterialAlternativo"
      : "Campanhas/InsCampanhaMaterialAlternativo";

    const [_, err, meta] = await handleApi(api.post(endpoint, body));

    setLoading(false);

    if (err) {
      showAlert(err, "error");
      return;
    }

    showAlert(meta?.message || "Alternativa gravada.", meta?.severity || "success");

    await carregarAlternativasMaterial(formAlternativa.idcampanhamaterial);
    fecharDialogAlternativas();
  };

  const apagarAlternativa = async (a) => {
    if (!a?.id) return;

    setLoading(true);

    const [_, err, meta] = await handleApi(
      api.post("Campanhas/DelCampanhaMaterialAlternativo", { id: a.id })
    );

    setLoading(false);

    if (err) {
      showAlert(err, "error");
      return;
    }

    showAlert(meta?.message || "Alternativa eliminada.", meta?.severity || "success");

    await carregarAlternativasMaterial(a.idcampanhamaterial);
  };

  const editarAlternativaGeral = (a) => {
    setFormAlternativaGeral({
      id: a.id,
      refmaterialalternativo: a.refmaterialalternativo || "",
      qtd: a.qtd || 1,
      unidade: a.unidade || "",
      obs: a.obs || "",
    });

    setAlternativaGeralInput(
      a.materialalternativo ? `${a.materialalternativo} (${a.refmaterialalternativo})` : ""
    );
  };

  const guardarAlternativaGeral = async () => {
    if (!form.id) {
      showAlert("Grava primeiro o cabeçalho da campanha.", "warning");
      return;
    }

    if (!formAlternativaGeral.refmaterialalternativo || Number(formAlternativaGeral.qtd) <= 0) {
      showAlert("Indica material alternativo e quantidade.", "warning");
      return;
    }

    setLoading(true);

    const body = {
      id: formAlternativaGeral.id,
      idcampanha: form.id,
      refmaterialalternativo: formAlternativaGeral.refmaterialalternativo,
      qtd: Number(formAlternativaGeral.qtd),
      unidade: formAlternativaGeral.unidade,
      obs: formAlternativaGeral.obs,
    };

    const endpoint = formAlternativaGeral.id
      ? "Campanhas/UpdCampanhaMaterialAlternativoGeral"
      : "Campanhas/InsCampanhaMaterialAlternativoGeral";

    const [_, err, meta] = await handleApi(api.post(endpoint, body));

    setLoading(false);

    if (err) {
      showAlert(err, "error");
      return;
    }

    showAlert(meta?.message || "Alternativa geral gravada.", meta?.severity || "success");

    setFormAlternativaGeral({
      id: null,
      refmaterialalternativo: "",
      qtd: 1,
      unidade: "",
      obs: "",
    });
    setAlternativaGeralInput("");

    await carregarAlternativasGerais(form.id);
  };

  const editarBeneficio = (b) => {
    setFormBeneficio({
      id: b.id,
      tipobeneficio: b.tipobeneficio || "VALOR_FIXO",
      basecalculo: b.basecalculo || "CONJUNTO",
      valor_eur: b.valor_eur ?? "",
      valor_por_unidade: b.valor_por_unidade ?? "",
      percentagem: b.percentagem ?? "",
      usar_iec: b.usar_iec === 1 ? 1 : 0,
      refmaterialgrupo_iec: b.refmaterialgrupo_iec || "",
      refmaterialoferta: b.refmaterialoferta || "",
      qtdoferta: b.qtdoferta ?? "",
      unidadeoferta: b.unidadeoferta || "",
      aplicaporconjunto: b.aplicaporconjunto || 1,
      limitevalor_eur: b.limitevalor_eur ?? "",
      obs: b.obs || "",
    });

    setOfertaInput(
      b.materialoferta ? `${b.materialoferta} (${b.refmaterialoferta})` : b.refmaterialoferta || ""
    );
  };

  const guardarBeneficio = async () => {
    alert("Entrou no guardarBeneficio");
    console.log("Entrou no guardarBeneficio", formBeneficio, form);

    if (!form.id) {
      showAlert("Grava primeiro o cabeçalho da campanha.", "warning");
      return;
    }

    if (!formBeneficio.tipobeneficio || !formBeneficio.basecalculo) {
      showAlert("Indica tipo de benefício e base de cálculo.", "warning");
      return;
    }

    if (formBeneficio.tipobeneficio === "ESPECIE") {
      if (
        !formBeneficio.refmaterialoferta ||
        Number(formBeneficio.qtdoferta) <= 0 ||
        !formBeneficio.unidadeoferta
      ) {
        showAlert("Indica material de oferta, quantidade e unidade.", "warning");
        return;
      }
    }

    setLoading(true);

    const body = {
      ...formBeneficio,
      idcampanha: form.id,
      valor_eur: formBeneficio.valor_eur === "" ? null : Number(formBeneficio.valor_eur),
      valor_por_unidade:
        formBeneficio.valor_por_unidade === "" ? null : Number(formBeneficio.valor_por_unidade),
      percentagem: formBeneficio.percentagem === "" ? null : Number(formBeneficio.percentagem),
      qtdoferta: formBeneficio.qtdoferta === "" ? null : Number(formBeneficio.qtdoferta),
      limitevalor_eur:
        formBeneficio.limitevalor_eur === "" ? null : Number(formBeneficio.limitevalor_eur),
      aplicaporconjunto: Number(formBeneficio.aplicaporconjunto || 1),
    };

    const endpoint = formBeneficio.id
      ? "Campanhas/UpdCampanhaBeneficio"
      : "Campanhas/InsCampanhaBeneficio";

    console.log("Benefício a gravar:", endpoint, body);

    const [_, err, meta] = await handleApi(api.post(endpoint, body));

    setLoading(false);

    if (err) {
      showAlert(err, "error");
      return;
    }

    showAlert(meta?.message || "Benefício gravado.", meta?.severity || "success");

    setFormBeneficio({
      id: null,
      tipobeneficio: "VALOR_FIXO",
      basecalculo: "CONJUNTO",
      valor_eur: "",
      valor_por_unidade: "",
      percentagem: "",
      usar_iec: 0,
      refmaterialgrupo_iec: "",
      refmaterialoferta: "",
      qtdoferta: "",
      unidadeoferta: "",
      aplicaporconjunto: 1,
      limitevalor_eur: "",
      obs: "",
    });

    setOfertaInput("");

    await carregarBeneficios(form.id);
  };

  const pedirValidacaoResultado = (r) => {
    if (!r?.id) return;
    setResultadoValidar(r);
    setOpenConfirmValidar(true);
  };

  const fecharConfirmValidar = () => {
    setOpenConfirmValidar(false);
    setResultadoValidar(null);
  };

  const validarResultado = async () => {
    if (!resultadoValidar?.id) return;

    setLoading(true);

    const [_, err, meta] = await handleApi(
      api.post("Campanhas/ValidarCampanhaFatura", {
        idcampanhafatura: resultadoValidar.id,
      })
    );

    setLoading(false);

    if (err) {
      showAlert(err, "error");
      return;
    }

    showAlert(meta?.message || "Resultado validado.", meta?.severity || "success");

    fecharConfirmValidar();
    await carregarResultados(form.id);
  };

  const abrirResultado = async (r) => {
    setResultadoSelecionado(r);
    setOpenResultado(true);

    const [linhasPayload, linhasErr] = await handleApi(
      api.post("Campanhas/SelCampanhasFaturasLinhas", { idcampanhafatura: r.id })
    );
    setResultadoLinhas(linhasErr ? [] : Array.isArray(linhasPayload) ? linhasPayload : []);
    if (linhasErr) showAlert(linhasErr, "error");

    const [beneficiosPayload, beneficiosErr] = await handleApi(
      api.post("Campanhas/SelCampanhasFaturasBeneficios", { idcampanhafatura: r.id })
    );
    setResultadoBeneficios(
      beneficiosErr ? [] : Array.isArray(beneficiosPayload) ? beneficiosPayload : []
    );
    if (beneficiosErr) showAlert(beneficiosErr, "error");

    const [recebimentosPayload, recebimentosErr] = await handleApi(
      api.post("Campanhas/SelCampanhasFaturasRecebimentos", { idcampanhafatura: r.id })
    );
    setResultadoRecebimentos(
      recebimentosErr ? [] : Array.isArray(recebimentosPayload) ? recebimentosPayload : []
    );
    if (recebimentosErr) showAlert(recebimentosErr, "error");
  };

  const abrirRecebimentos = async (idcampanha = form.id) => {
    if (!idcampanha) {
      showAlert("Seleciona primeiro uma campanha.", "warning");
      return;
    }

    const [payload, err] = await handleApi(
      api.post("Campanhas/SelCampanhasFaturas", { idcampanha })
    );

    if (err) {
      showAlert(err, "error");
      return;
    }

    const [histPayload, histErr] = await handleApi(
      api.post("Campanhas/SelCampanhasFaturasRecebimentos", { idcampanha })
    );

    setHistoricoRecebimentosCampanha(histErr ? [] : Array.isArray(histPayload) ? histPayload : []);
    if (histErr) showAlert(histErr, "error");

    const linhas = (Array.isArray(payload) ? payload : [])
      .filter((r) => ["Detetado", "Validado", "Solicitado", "Parcial"].includes(r.estado))
      .map((r) => {
        const valorAReceber = Number(r.valor_a_receber || 0);
        const valorRecebido = Number(r.valor_total_recebido || 0);
        const valorEmFalta = Math.max(0, valorAReceber - valorRecebido);

        return {
          ...r,
          selecionado: false,
          novo_recebimento: 0,
          valor_em_falta: valorEmFalta,
        };
      });

    setRecebimentosLinhas(linhas);
    setRecebimentosForm({
      datarecebimento: new Date().toISOString().substring(0, 10),
      docref: "",
      obs: "",
    });
    setOpenRecebimentos(true);
  };

  const gravarRecebimentos = async () => {
    const itens = recebimentosLinhas
      .filter((x) => x.selecionado && Number(x.novo_recebimento || 0) !== 0)
      .map((x) => ({
        idcampanhafatura: x.id,
        valor_recebido: Number(x.novo_recebimento || 0),
      }));

    if (itens.length === 0) {
      showAlert("Não existem recebimentos selecionados para gravar.", "warning");
      return;
    }

    setLoading(true);

    const [_, err, meta] = await handleApi(
      api.post("Campanhas/InsCampanhasFaturasRecebimentosLote", {
        itens,
        datarecebimento: recebimentosForm.datarecebimento,
        docref: recebimentosForm.docref,
        obs: recebimentosForm.obs,
        criado_por: userData?.id || null,
      })
    );

    setLoading(false);

    if (err) {
      showAlert(err, "error");
      return;
    }

    showAlert(meta?.message || "Recebimentos gravados.", meta?.severity || "success");

    setOpenRecebimentos(false);
    await carregarResultados(form.id);
  };

  const processar = async (row) => {
    setLoading(true);

    const [_, err, meta] = await handleApi(
      api.post("Campanhas/ProcessarCampanhas", { idcampanha: row.id })
    );

    setLoading(false);

    if (err) {
      showAlert(err, "error");
      return;
    }

    showAlert(meta?.message || "Processamento executado.", meta?.severity || "success");

    await carregarResultados(row.id);
    await carregar();
  };

  const columns = useMemo(
    () => [
      {
        Header: "",
        id: "acoes",
        disableFilters: true,
        width: 88,
        Cell: ({ row }) => {
          const c = row.original;
          return (
            <div style={{ display: "flex", gap: 4, whiteSpace: "nowrap" }}>
              <IconButton
                size="small"
                color="primary"
                disabled={!temPermissao("Menu Comercial", "u")}
                onClick={() => handleOpenEditar(c)}
                title="Editar campanha"
              >
                <EditIcon fontSize="small" />
              </IconButton>

              <IconButton
                size="small"
                color="success"
                disabled={!temPermissao("Menu Comercial", "u")}
                onClick={() => processar(c)}
                title="Processar/detetar resultados"
              >
                <PlayArrowIcon fontSize="small" />
              </IconButton>

              <IconButton
                size="small"
                color="info"
                disabled={!temPermissao("Menu Comercial", "r")}
                onClick={() => abrirResultadosCampanha(c)}
                title="Ver resultados detetados"
              >
                <InfoIcon fontSize="small" />
              </IconButton>

              <IconButton
                size="small"
                color="success"
                disabled={!temPermissao("Menu Comercial", "u")}
                onClick={() => abrirRecebimentos(c.id)}
                title="Registar recebimentos"
              >
                <PaymentsIcon fontSize="small" />
              </IconButton>
            </div>
          );
        },
      },
      { Header: "Campanha", accessor: "nome", Filter: TextFilter },
      { Header: "Código", accessor: "codigo_campanha", Filter: TextFilter },
      { Header: "Fabricante", accessor: "fabricante", Filter: TextFilter },
      { Header: "Contacto", accessor: "contacto_nome", Filter: TextFilter },
      {
        Header: "Data inicial",
        accessor: "datainicial",
        Filter: TextFilter,
        Cell: ({ value }) => (value ? String(value).substring(0, 10) : ""),
      },
      {
        Header: "Data final",
        accessor: "datafinal",
        Filter: TextFilter,
        Cell: ({ value }) => (value ? String(value).substring(0, 10) : ""),
      },
      { Header: "Estado", accessor: "estado_periodo", Filter: TextFilter },
      {
        Header: "Email",
        accessor: "enviaremail",
        Filter: TextFilter,
        Cell: ({ value }) => (value === 1 ? "Sim" : "Não"),
      },
    ],
    [temPermissao]
  );

  const table = useTable(
    {
      columns,
      data,
      initialState: { filters: initialFilters },
      autoResetFilters: false,
      autoResetSortBy: false,
    },
    useFilters,
    useSortBy
  );

  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow, setAllFilters, state } =
    table;

  useEffect(() => {
    try {
      localStorage.setItem(KEEP_KEY, JSON.stringify(keepFilters));
    } catch {}

    if (!keepFilters) {
      setAllFilters([]);
      try {
        localStorage.removeItem(FILTERS_KEY);
      } catch {}
    }
  }, [keepFilters, setAllFilters]);

  useEffect(() => {
    if (!keepFilters) return;
    try {
      localStorage.setItem(FILTERS_KEY, JSON.stringify(state.filters || []));
    } catch {}
  }, [state.filters, keepFilters]);

  const tipoBeneficio = formBeneficio.tipobeneficio;

  const mostrarValorEur = tipoBeneficio === "VALOR_FIXO";
  const mostrarValorUnidade = tipoBeneficio === "VALOR_POR_UNIDADE";
  const mostrarPercentagem = tipoBeneficio === "PERCENTAGEM";
  const mostrarOferta = tipoBeneficio === "ESPECIE";

  const abrirResultadosCampanha = async (campanha) => {
    if (!campanha?.id) return;

    setCampanhaResultados(campanha);
    await carregarResultados(campanha.id);
    setOpenResultadosCampanha(true);
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />

      {loading && (
        <MDBox py={2} display="flex" alignItems="center" justifyContent="center">
          <CircularProgress />
        </MDBox>
      )}

      <PageHeader />

      <MDBox pt={1}>
        <Card>
          <MDBox p={3}>
            <MDBox display="flex" justifyContent="space-between" alignItems="center" mb={2}>
              <MDTypography variant="h6">Campanhas comerciais</MDTypography>

              <MDBox display="flex" alignItems="center" gap={1}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={keepFilters}
                      onChange={(e) => setKeepFilters(e.target.checked)}
                      size="small"
                    />
                  }
                  label="Manter filtros"
                />

                <MDButton
                  color="success"
                  disabled={!temPermissao("Menu Comercial", "w")}
                  onClick={handleOpenNovo}
                >
                  Nova Campanha
                </MDButton>
              </MDBox>
            </MDBox>

            <MDBox sx={{ height: "68vh", overflow: "auto", borderRadius: 1 }}>
              <table {...getTableProps()} style={{ width: "100%", borderCollapse: "collapse" }}>
                <thead>
                  {headerGroups.map((hg) => (
                    <tr {...hg.getHeaderGroupProps()}>
                      {hg.headers.map((col) => (
                        <th
                          {...col.getHeaderProps(col.getSortByToggleProps())}
                          style={{
                            position: "sticky",
                            top: 0,
                            zIndex: 2,
                            background: "#fff",
                            textAlign: "left",
                            padding: "6px 8px",
                            fontSize: 12,
                            color: "#7b809a",
                            verticalAlign: "bottom",
                            boxShadow: "0 2px 4px rgba(0,0,0,0.06)",
                            width: col.id === "acoes" ? 88 : undefined,
                          }}
                        >
                          <div>
                            {col.render("Header")}
                            {col.isSorted ? (col.isSortedDesc ? " ▼" : " ▲") : null}
                          </div>

                          {!col.disableFilters && (
                            <div onClick={(e) => e.stopPropagation()} style={{ marginTop: 4 }}>
                              {col.canFilter ? col.render("Filter") : null}
                            </div>
                          )}
                        </th>
                      ))}
                    </tr>
                  ))}
                </thead>

                <tbody {...getTableBodyProps()}>
                  {rows.map((row) => {
                    prepareRow(row);
                    return (
                      <tr {...row.getRowProps()}>
                        {row.cells.map((cell) => (
                          <td
                            {...cell.getCellProps()}
                            style={{
                              padding: "8px 10px",
                              borderTop: "1px solid #eee",
                              fontSize: 12,
                              color: "#1a2b4c",
                              width: cell.column.id === "acoes" ? 88 : undefined,
                              whiteSpace: "nowrap",
                            }}
                          >
                            {cell.render("Cell")}
                          </td>
                        ))}
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </MDBox>
          </MDBox>
        </Card>
      </MDBox>

      <Dialog
        PaperComponent={PaperComponent}
        open={openDialog}
        onClose={() => setOpenDialog(false)}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle id="draggable-dialog-title" style={{ cursor: "move" }}>
          {editando ? "Editar campanha" : "Nova campanha"}
        </DialogTitle>

        <DialogContent>
          <MDBox display="grid" gap={1.5} mt={1}>
            <MDInput
              label="Nome"
              value={form.nome}
              onChange={(e) => setForm((p) => ({ ...p, nome: e.target.value }))}
              fullWidth
            />

            <MDInput
              label="Código da campanha"
              value={form.codigo_campanha}
              onChange={(e) => setForm((p) => ({ ...p, codigo_campanha: e.target.value }))}
              fullWidth
            />

            <div>
              <div style={{ fontSize: 12, color: "#7b809a", marginBottom: 4 }}>Fabricante</div>
              <Autocomplete
                size="small"
                options={fabricantes}
                filterOptions={(x) => x}
                inputValue={fabricanteInput}
                getOptionLabel={(option) => (option?.nome ? `${option.nome} (${option.ref})` : "")}
                value={fabricantes.find((f) => f.ref === form.reffabricante) || null}
                onInputChange={(_, value, reason) => {
                  if (reason === "input") {
                    setFabricanteInput(value);
                    setForm((p) => ({
                      ...p,
                      reffabricante: "",
                      idfabricantecontacto: "",
                    }));
                    setContactos([]);
                    carregarFabricantes(value);
                  }

                  if (reason === "clear") {
                    setFabricanteInput("");
                  }
                }}
                onChange={async (_, value) => {
                  const ref = value?.ref || "";

                  setForm((p) => ({
                    ...p,
                    reffabricante: ref,
                    idfabricantecontacto: "",
                  }));

                  setFabricanteInput(value?.nome ? `${value.nome} (${value.ref})` : "");
                  await carregarContactos(ref);
                }}
                renderInput={(params) => <TextField {...params} placeholder="Selecione..." />}
              />
            </div>

            <div>
              <div style={{ fontSize: 12, color: "#7b809a", marginBottom: 4 }}>
                Contacto do fabricante
              </div>
              <Autocomplete
                size="small"
                options={contactos}
                getOptionLabel={(option) =>
                  option?.nome ? `${option.nome}${option.email ? ` (${option.email})` : ""}` : ""
                }
                value={
                  contactos.find((c) => String(c.id) === String(form.idfabricantecontacto)) || null
                }
                onChange={(_, value) =>
                  setForm((p) => ({ ...p, idfabricantecontacto: value?.id || "" }))
                }
                renderInput={(params) => <TextField {...params} placeholder="Selecione..." />}
              />
            </div>

            <MDBox display="grid" gridTemplateColumns="1fr 1fr" gap={1.5}>
              <MDInput
                label="Data inicial"
                type="date"
                value={form.datainicial}
                onChange={(e) => setForm((p) => ({ ...p, datainicial: e.target.value }))}
                fullWidth
                InputLabelProps={{ shrink: true }}
              />

              <MDInput
                label="Data final"
                type="date"
                value={form.datafinal}
                onChange={(e) => setForm((p) => ({ ...p, datafinal: e.target.value }))}
                fullWidth
                InputLabelProps={{ shrink: true }}
              />
            </MDBox>

            <FormControlLabel
              control={
                <Checkbox
                  checked={form.enviaremail === 1}
                  onChange={(e) =>
                    setForm((p) => ({ ...p, enviaremail: e.target.checked ? 1 : 0 }))
                  }
                  size="small"
                />
              }
              label="Enviar email ao criar campanha"
            />

            <MDInput
              label="Observações"
              value={form.obs}
              onChange={(e) => setForm((p) => ({ ...p, obs: e.target.value }))}
              fullWidth
              multiline
              rows={3}
            />

            {editando && (
              <MDBox display="grid" gap={2}>
                <MDBox mt={2} p={2} sx={{ border: "1px solid #e0e0e0", borderRadius: 2 }}>
                  <MDBox display="flex" justifyContent="space-between" alignItems="center" mb={2}>
                    <MDTypography variant="h6">Materiais principais</MDTypography>
                    <MDButton color="success" onClick={abrirNovoMaterial}>
                      Novo material
                    </MDButton>
                  </MDBox>

                  <table style={{ width: "100%", borderCollapse: "collapse" }}>
                    <thead>
                      <tr>
                        <th style={{ textAlign: "left", fontSize: 12, padding: 6 }}>Ref.</th>
                        <th style={{ textAlign: "left", fontSize: 12, padding: 6 }}>Material</th>
                        <th style={{ textAlign: "right", fontSize: 12, padding: 6 }}>Qtd</th>
                        <th style={{ textAlign: "left", fontSize: 12, padding: 6 }}>Unid.</th>
                        <th style={{ textAlign: "left", fontSize: 12, padding: 6 }}>Obs</th>
                        <th style={{ width: 150 }} />
                      </tr>
                    </thead>

                    <tbody>
                      {materiaisCampanha.map((m) => {
                        const alternativas = alternativasPorMaterial[m.id] || [];

                        return (
                          <React.Fragment key={m.id}>
                            <tr>
                              <td style={{ fontSize: 12, padding: 6, borderTop: "1px solid #eee" }}>
                                {m.refmaterial}
                              </td>
                              <td style={{ fontSize: 12, padding: 6, borderTop: "1px solid #eee" }}>
                                {m.material}
                              </td>
                              <td
                                style={{
                                  fontSize: 12,
                                  padding: 6,
                                  borderTop: "1px solid #eee",
                                  textAlign: "right",
                                }}
                              >
                                {m.qtd}
                              </td>
                              <td style={{ fontSize: 12, padding: 6, borderTop: "1px solid #eee" }}>
                                {m.unidade}
                              </td>
                              <td style={{ fontSize: 12, padding: 6, borderTop: "1px solid #eee" }}>
                                {m.obs}
                              </td>
                              <td style={{ borderTop: "1px solid #eee", whiteSpace: "nowrap" }}>
                                <IconButton
                                  size="small"
                                  color="primary"
                                  onClick={() => abrirEditarMaterial(m)}
                                  title="Editar"
                                >
                                  <EditIcon fontSize="small" />
                                </IconButton>

                                <IconButton
                                  size="small"
                                  color="error"
                                  onClick={() => pedirEliminarMaterial(m)}
                                  title="Eliminar"
                                >
                                  <DeleteIcon fontSize="small" />
                                </IconButton>

                                <MDButton
                                  color="info"
                                  size="small"
                                  onClick={() => abrirAlternativas(m)}
                                  style={{ marginLeft: 4 }}
                                >
                                  Nova alt.
                                </MDButton>
                              </td>
                            </tr>

                            {alternativas.map((a) => (
                              <tr key={`alt-${a.id}`}>
                                <td />
                                <td
                                  colSpan={4}
                                  style={{
                                    fontSize: 12,
                                    padding: "5px 6px 5px 24px",
                                    color: "#6c757d",
                                    borderTop: "1px dashed #eee",
                                    background: "#fafafa",
                                  }}
                                >
                                  ↳ {a.refmaterialalternativo} — {a.materialalternativo} | Qtd:{" "}
                                  {a.qtd} {a.unidade || ""} {a.obs ? `| ${a.obs}` : ""}
                                </td>
                                <td
                                  style={{
                                    borderTop: "1px dashed #eee",
                                    background: "#fafafa",
                                    whiteSpace: "nowrap",
                                  }}
                                >
                                  <IconButton
                                    size="small"
                                    color="primary"
                                    onClick={() => abrirEditarAlternativa(m, a)}
                                    title="Editar alternativa"
                                  >
                                    <EditIcon fontSize="small" />
                                  </IconButton>

                                  <IconButton
                                    size="small"
                                    color="error"
                                    onClick={() => apagarAlternativa(a)}
                                    title="Eliminar alternativa"
                                  >
                                    <DeleteIcon fontSize="small" />
                                  </IconButton>
                                </td>
                              </tr>
                            ))}
                          </React.Fragment>
                        );
                      })}
                    </tbody>
                  </table>
                </MDBox>

                <MDBox mt={2} p={2} sx={{ border: "1px solid #e0e0e0", borderRadius: 2 }}>
                  <MDTypography variant="h6" mb={1}>
                    Alternativas gerais
                  </MDTypography>

                  <MDBox display="flex" flexWrap="wrap" gap={1} mb={2} alignItems="flex-end">
                    <MDBox sx={{ minWidth: 280, flex: "1 1 280px" }}>
                      <Autocomplete
                        size="small"
                        options={materiaisCombo}
                        filterOptions={(x) => x}
                        inputValue={alternativaGeralInput}
                        getOptionLabel={materialLabel}
                        value={
                          materiaisCombo.find(
                            (m) => m.ref === formAlternativaGeral.refmaterialalternativo
                          ) || null
                        }
                        onInputChange={(_, value, reason) => {
                          if (reason === "input") {
                            setAlternativaGeralInput(value);
                            setFormAlternativaGeral((p) => ({
                              ...p,
                              refmaterialalternativo: "",
                            }));
                            carregarMateriaisCombo(value);
                          }

                          if (reason === "clear") {
                            setAlternativaGeralInput("");
                            setFormAlternativaGeral((p) => ({
                              ...p,
                              refmaterialalternativo: "",
                            }));
                          }
                        }}
                        onChange={(_, value) => {
                          setFormAlternativaGeral((p) => ({
                            ...p,
                            refmaterialalternativo: value?.ref || "",
                            unidade: value?.refmaterialunidade || "",
                          }));

                          setAlternativaGeralInput(value ? materialLabel(value) : "");
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label="Material alternativo"
                            placeholder="Pesquisar..."
                          />
                        )}
                      />
                    </MDBox>

                    <MDBox sx={{ width: 90 }}>
                      <MDInput
                        label="Qtd"
                        type="number"
                        size="small"
                        value={formAlternativaGeral.qtd}
                        onChange={(e) =>
                          setFormAlternativaGeral((p) => ({ ...p, qtd: e.target.value }))
                        }
                        fullWidth
                      />
                    </MDBox>

                    <MDBox sx={{ width: 95 }}>
                      <MDInput
                        label="Unid."
                        size="small"
                        value={formAlternativaGeral.unidade}
                        onChange={(e) =>
                          setFormAlternativaGeral((p) => ({ ...p, unidade: e.target.value }))
                        }
                        fullWidth
                      />
                    </MDBox>

                    <MDBox sx={{ minWidth: 220, flex: "1 1 220px" }}>
                      <MDInput
                        label="Obs"
                        size="small"
                        value={formAlternativaGeral.obs}
                        onChange={(e) =>
                          setFormAlternativaGeral((p) => ({ ...p, obs: e.target.value }))
                        }
                        fullWidth
                      />
                    </MDBox>

                    <MDButton color="success" onClick={guardarAlternativaGeral}>
                      {formAlternativaGeral.id ? "Atualizar" : "Adicionar"}
                    </MDButton>
                  </MDBox>

                  {alternativasGerais.map((a) => (
                    <MDBox
                      key={a.id}
                      display="grid"
                      gridTemplateColumns="2fr 2fr 0.7fr 0.7fr 2fr auto"
                      gap={1}
                      alignItems="center"
                      py={0.5}
                      sx={{ borderTop: "1px solid #e0e0e0" }}
                    >
                      <MDTypography variant="caption">{a.refmaterialalternativo}</MDTypography>
                      <MDTypography variant="caption">{a.materialalternativo}</MDTypography>
                      <MDTypography variant="caption">{a.qtd}</MDTypography>
                      <MDTypography variant="caption">{a.unidade}</MDTypography>
                      <MDTypography variant="caption">{a.obs}</MDTypography>
                      <IconButton
                        size="small"
                        color="primary"
                        onClick={() => editarAlternativaGeral(a)}
                      >
                        <EditIcon fontSize="small" />
                      </IconButton>
                    </MDBox>
                  ))}
                </MDBox>

                <MDBox mt={2} p={2} sx={{ border: "1px solid #e0e0e0", borderRadius: 2 }}>
                  <MDTypography variant="h6" mb={1}>
                    Benefícios
                  </MDTypography>

                  <MDBox display="flex" flexWrap="wrap" gap={1} mb={2} alignItems="flex-end">
                    <select
                      value={formBeneficio.tipobeneficio}
                      onChange={(e) => {
                        setFormBeneficio((p) => ({
                          ...p,
                          tipobeneficio: e.target.value,
                          valor_eur: "",
                          valor_por_unidade: "",
                          percentagem: "",
                          refmaterialoferta: "",
                          qtdoferta: "",
                          unidadeoferta: "",
                        }));
                        setOfertaInput("");
                      }}
                      style={{
                        padding: 9,
                        borderRadius: 6,
                        border: "1px solid #d2d6da",
                        minWidth: 180,
                      }}
                    >
                      <option value="VALOR_FIXO">Valor fixo</option>
                      <option value="VALOR_POR_UNIDADE">Valor por unidade</option>
                      <option value="PERCENTAGEM">Percentagem</option>
                      <option value="ESPECIE">Espécie</option>
                    </select>

                    <select
                      value={formBeneficio.basecalculo}
                      onChange={(e) =>
                        setFormBeneficio((p) => ({ ...p, basecalculo: e.target.value }))
                      }
                      style={{
                        padding: 9,
                        borderRadius: 6,
                        border: "1px solid #d2d6da",
                        minWidth: 160,
                      }}
                    >
                      <option value="CONJUNTO">Conjunto</option>
                      <option value="LINHA">Linha</option>
                      <option value="VALOR">Valor</option>
                      <option value="VALOR_SEM_IEC">Valor sem IEC</option>
                      <option value="QTD">Quantidade</option>
                      <option value="VOLUME">Volume</option>
                    </select>

                    {mostrarValorEur && (
                      <MDBox sx={{ width: 130 }}>
                        <MDInput
                          label="Valor €"
                          type="number"
                          value={formBeneficio.valor_eur}
                          onChange={(e) =>
                            setFormBeneficio((p) => ({ ...p, valor_eur: e.target.value }))
                          }
                          fullWidth
                        />
                      </MDBox>
                    )}

                    {mostrarValorUnidade && (
                      <MDBox sx={{ width: 160 }}>
                        <MDInput
                          label="Valor por unidade"
                          type="number"
                          value={formBeneficio.valor_por_unidade}
                          onChange={(e) =>
                            setFormBeneficio((p) => ({ ...p, valor_por_unidade: e.target.value }))
                          }
                          fullWidth
                        />
                      </MDBox>
                    )}

                    {mostrarPercentagem && (
                      <MDBox sx={{ width: 120 }}>
                        <MDInput
                          label="%"
                          type="number"
                          value={formBeneficio.percentagem}
                          onChange={(e) =>
                            setFormBeneficio((p) => ({ ...p, percentagem: e.target.value }))
                          }
                          fullWidth
                        />
                      </MDBox>
                    )}

                    <MDBox sx={{ width: 130 }}>
                      <MDInput
                        label="Aplica/conj."
                        type="number"
                        value={formBeneficio.aplicaporconjunto}
                        onChange={(e) =>
                          setFormBeneficio((p) => ({ ...p, aplicaporconjunto: e.target.value }))
                        }
                        fullWidth
                      />
                    </MDBox>

                    <MDButton color="success" onClick={guardarBeneficio}>
                      {formBeneficio.id ? "Atualizar" : "Adicionar"}
                    </MDButton>
                  </MDBox>

                  {mostrarOferta && (
                    <MDBox display="grid" gridTemplateColumns="1fr 1fr 1fr 1fr" gap={1} mb={2}>
                      <Autocomplete
                        size="small"
                        options={materiaisCombo}
                        filterOptions={(x) => x}
                        inputValue={ofertaInput}
                        getOptionLabel={materialLabel}
                        value={
                          materiaisCombo.find((m) => m.ref === formBeneficio.refmaterialoferta) ||
                          null
                        }
                        onInputChange={(_, value, reason) => {
                          if (reason === "input") {
                            setOfertaInput(value);
                            setFormBeneficio((p) => ({
                              ...p,
                              refmaterialoferta: "",
                              unidadeoferta: "",
                            }));
                            carregarMateriaisCombo(value);
                          }

                          if (reason === "clear") {
                            setOfertaInput("");
                            setFormBeneficio((p) => ({
                              ...p,
                              refmaterialoferta: "",
                              unidadeoferta: "",
                            }));
                          }
                        }}
                        onChange={(_, value) => {
                          setFormBeneficio((p) => ({
                            ...p,
                            refmaterialoferta: value?.ref || "",
                            unidadeoferta: value?.refmaterialunidade || "",
                          }));

                          setOfertaInput(value ? materialLabel(value) : "");
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label="Material oferta"
                            placeholder="Pesquisar..."
                          />
                        )}
                      />

                      <MDInput
                        label="Qtd oferta"
                        type="number"
                        value={formBeneficio.qtdoferta}
                        onChange={(e) =>
                          setFormBeneficio((p) => ({ ...p, qtdoferta: e.target.value }))
                        }
                        fullWidth
                      />

                      <MDInput
                        label="Unidade oferta"
                        value={formBeneficio.unidadeoferta}
                        onChange={(e) =>
                          setFormBeneficio((p) => ({ ...p, unidadeoferta: e.target.value }))
                        }
                        fullWidth
                      />

                      <MDInput
                        label="Obs"
                        value={formBeneficio.obs}
                        onChange={(e) => setFormBeneficio((p) => ({ ...p, obs: e.target.value }))}
                        fullWidth
                      />
                    </MDBox>
                  )}

                  {beneficios.map((b) => (
                    <MDBox
                      key={b.id}
                      display="grid"
                      gridTemplateColumns="1fr 1fr 1fr 1fr 1fr auto"
                      gap={1}
                      alignItems="center"
                      py={0.5}
                      sx={{ borderTop: "1px solid #e0e0e0" }}
                    >
                      <MDTypography variant="caption">{b.tipobeneficio}</MDTypography>
                      <MDTypography variant="caption">{b.basecalculo}</MDTypography>
                      <MDTypography variant="caption">{b.valor_eur}</MDTypography>
                      <MDTypography variant="caption">{b.percentagem}</MDTypography>
                      <MDTypography variant="caption">
                        {b.refmaterialoferta
                          ? `${b.qtdoferta || ""} ${b.unidadeoferta || ""} ${b.refmaterialoferta}`
                          : ""}
                      </MDTypography>
                      <IconButton size="small" color="primary" onClick={() => editarBeneficio(b)}>
                        <EditIcon fontSize="small" />
                      </IconButton>
                    </MDBox>
                  ))}
                </MDBox>
              </MDBox>
            )}
          </MDBox>
        </DialogContent>

        <DialogActions>
          <MDButton color="secondary" onClick={() => setOpenDialog(false)}>
            Cancelar
          </MDButton>
          <MDButton color="success" onClick={guardar}>
            Guardar
          </MDButton>
        </DialogActions>
      </Dialog>

      <Dialog
        PaperComponent={PaperComponent}
        open={openDialogMaterial}
        onClose={fecharDialogMaterial}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle id="draggable-dialog-title" style={{ cursor: "move" }}>
          {formMaterial.id ? "Editar material" : "Novo material"}
        </DialogTitle>

        <DialogContent>
          <MDBox display="grid" gap={1.5} mt={1}>
            <div>
              <div style={{ fontSize: 12, color: "#7b809a", marginBottom: 4 }}>Material</div>
              <Autocomplete
                size="small"
                options={materiaisCombo}
                filterOptions={(x) => x}
                inputValue={materialInput}
                getOptionLabel={materialLabel}
                value={materiaisCombo.find((m) => m.ref === formMaterial.refmaterial) || null}
                onInputChange={(_, value, reason) => {
                  if (reason === "input") {
                    setMaterialInput(value);
                    setFormMaterial((p) => ({ ...p, refmaterial: "" }));
                    carregarMateriaisCombo(value);
                  }

                  if (reason === "clear") {
                    setMaterialInput("");
                    setFormMaterial((p) => ({ ...p, refmaterial: "" }));
                  }
                }}
                onChange={(_, value) => {
                  setFormMaterial((p) => ({
                    ...p,
                    refmaterial: value?.ref || "",
                    unidade: value?.refmaterialunidade || p.unidade,
                  }));

                  setMaterialInput(value ? materialLabel(value) : "");
                }}
                renderInput={(params) => <TextField {...params} placeholder="Selecione..." />}
              />
            </div>

            <MDBox display="grid" gridTemplateColumns="1fr 1fr" gap={1.5}>
              <MDInput
                label="Quantidade"
                type="number"
                value={formMaterial.qtd}
                onChange={(e) => setFormMaterial((p) => ({ ...p, qtd: e.target.value }))}
                fullWidth
              />

              <MDInput
                label="Unidade"
                value={formMaterial.unidade}
                onChange={(e) => setFormMaterial((p) => ({ ...p, unidade: e.target.value }))}
                fullWidth
              />
            </MDBox>

            <MDInput
              label="Observações"
              value={formMaterial.obs}
              onChange={(e) => setFormMaterial((p) => ({ ...p, obs: e.target.value }))}
              fullWidth
              multiline
              rows={3}
            />
          </MDBox>
        </DialogContent>

        <DialogActions>
          <MDButton color="secondary" onClick={fecharDialogMaterial}>
            Cancelar
          </MDButton>
          <MDButton color="success" onClick={guardarMaterial}>
            Guardar
          </MDButton>
        </DialogActions>
      </Dialog>

      <Dialog
        PaperComponent={PaperComponent}
        open={openDialogAlternativas}
        onClose={fecharDialogAlternativas}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle id="draggable-dialog-title" style={{ cursor: "move" }}>
          Alternativas —{" "}
          {materialAlternativasSelecionado?.material ||
            materialAlternativasSelecionado?.refmaterial ||
            ""}
        </DialogTitle>

        <DialogContent>
          <MDBox display="grid" gap={2} mt={1}>
            <MDBox p={2} sx={{ border: "1px solid #e0e0e0", borderRadius: 2 }}>
              <MDTypography variant="h6" mb={1}>
                Nova / editar alternativa
              </MDTypography>

              <MDBox display="grid" gridTemplateColumns="2fr 0.7fr 0.7fr 2fr auto" gap={1}>
                <Autocomplete
                  size="small"
                  options={materiaisCombo.filter(
                    (m) =>
                      m.ref !== materialAlternativasSelecionado?.refmaterial &&
                      !(alternativasPorMaterial[materialAlternativasSelecionado?.id] || []).some(
                        (a) => a.refmaterialalternativo === m.ref
                      )
                  )}
                  filterOptions={(x) => x}
                  inputValue={alternativaInput}
                  getOptionLabel={materialLabel}
                  value={
                    materiaisCombo.find((m) => m.ref === formAlternativa.refmaterialalternativo) ||
                    null
                  }
                  onInputChange={(_, value, reason) => {
                    if (reason === "input") {
                      setAlternativaInput(value);
                      setFormAlternativa((p) => ({ ...p, refmaterialalternativo: "" }));
                      carregarMateriaisCombo(value);
                    }

                    if (reason === "clear") {
                      setAlternativaInput("");
                      setFormAlternativa((p) => ({ ...p, refmaterialalternativo: "" }));
                    }
                  }}
                  onChange={(_, value) => {
                    setFormAlternativa((p) => ({
                      ...p,
                      refmaterialalternativo: value?.ref || "",
                      unidade: value?.refmaterialunidade || p.unidade,
                    }));

                    setAlternativaInput(value ? materialLabel(value) : "");
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Material alternativo"
                      placeholder="Pesquisar..."
                    />
                  )}
                />

                <MDInput
                  label="Qtd"
                  type="number"
                  value={formAlternativa.qtd}
                  onChange={(e) => setFormAlternativa((p) => ({ ...p, qtd: e.target.value }))}
                  fullWidth
                />

                <MDInput
                  label="Unid."
                  value={formAlternativa.unidade}
                  onChange={(e) => setFormAlternativa((p) => ({ ...p, unidade: e.target.value }))}
                  fullWidth
                />

                <MDInput
                  label="Obs"
                  value={formAlternativa.obs}
                  onChange={(e) => setFormAlternativa((p) => ({ ...p, obs: e.target.value }))}
                  fullWidth
                />

                <MDButton color="success" onClick={guardarAlternativa}>
                  {formAlternativa.id ? "Atualizar" : "Adicionar"}
                </MDButton>
              </MDBox>
            </MDBox>
          </MDBox>
        </DialogContent>

        <DialogActions>
          <MDButton color="secondary" onClick={fecharDialogAlternativas}>
            Fechar
          </MDButton>
        </DialogActions>
      </Dialog>

      <Dialog
        open={openConfirmDelMaterial}
        onClose={fecharConfirmDelMaterial}
        maxWidth="xs"
        fullWidth
      >
        <DialogTitle id="draggable-dialog-title" style={{ cursor: "move" }}>
          Eliminar material
        </DialogTitle>
        <DialogContent>
          Tem a certeza que pretende eliminar o material{" "}
          <strong>
            {materialParaEliminar?.material || materialParaEliminar?.refmaterial || ""}
          </strong>
          ?
        </DialogContent>
        <DialogActions>
          <MDButton onClick={fecharConfirmDelMaterial} color="secondary">
            Cancelar
          </MDButton>
          <MDButton onClick={confirmarEliminarMaterial} color="error">
            Eliminar
          </MDButton>
        </DialogActions>
      </Dialog>

      <Dialog
        PaperComponent={PaperComponent}
        open={openConfirmValidar}
        onClose={fecharConfirmValidar}
        maxWidth="xs"
        fullWidth
      >
        <DialogTitle id="draggable-dialog-title" style={{ cursor: "move" }}>
          Validar resultado
        </DialogTitle>
        <DialogContent>
          Tem a certeza que pretende validar o resultado da fatura{" "}
          <strong>{resultadoValidar?.faturaorigem}</strong>?
        </DialogContent>
        <DialogActions>
          <MDButton onClick={fecharConfirmValidar} color="secondary">
            Cancelar
          </MDButton>
          <MDButton onClick={validarResultado} color="success">
            Validar
          </MDButton>
        </DialogActions>
      </Dialog>

      <Dialog
        open={openRecebimentos}
        onClose={() => setOpenRecebimentos(false)}
        maxWidth="lg"
        fullWidth
      >
        <DialogTitle id="draggable-dialog-title" style={{ cursor: "move" }}>
          Registar recebimentos da campanha
        </DialogTitle>

        <DialogContent>
          <MDBox display="grid" gap={2} mt={1}>
            <MDBox display="grid" gridTemplateColumns="1fr 1fr 2fr" gap={1}>
              <MDInput
                label="Data recebimento"
                type="date"
                value={recebimentosForm.datarecebimento}
                onChange={(e) =>
                  setRecebimentosForm((p) => ({ ...p, datarecebimento: e.target.value }))
                }
                fullWidth
                InputLabelProps={{ shrink: true }}
              />

              <MDInput
                label="Documento/ref."
                value={recebimentosForm.docref}
                onChange={(e) => setRecebimentosForm((p) => ({ ...p, docref: e.target.value }))}
                fullWidth
              />

              <MDInput
                label="Observações"
                value={recebimentosForm.obs}
                onChange={(e) => setRecebimentosForm((p) => ({ ...p, obs: e.target.value }))}
                fullWidth
              />
            </MDBox>

            <MDBox display="flex" justifyContent="space-between" alignItems="center">
              <MDButton
                color="info"
                onClick={() => {
                  const todasSelecionadas = recebimentosLinhas.every((x) => x.selecionado);

                  setRecebimentosLinhas((prev) =>
                    prev.map((x) => ({
                      ...x,
                      selecionado: !todasSelecionadas,
                      novo_recebimento: !todasSelecionadas ? Number(x.valor_em_falta || 0) : 0,
                    }))
                  );
                }}
              >
                {recebimentosLinhas.every((x) => x.selecionado)
                  ? "Desselecionar todas"
                  : "Selecionar todas"}
              </MDButton>

              <MDTypography variant="caption">
                Ao selecionar, o novo recebimento é preenchido com o valor em falta.
              </MDTypography>
            </MDBox>

            <MDBox sx={{ maxHeight: 420, overflow: "auto" }}>
              <table style={{ width: "100%", borderCollapse: "collapse" }}>
                <thead>
                  <tr>
                    <th style={{ textAlign: "left", fontSize: 12, padding: 6 }}>Fatura</th>
                    <th style={{ textAlign: "center", fontSize: 12, padding: 6 }}>Recebida</th>
                    <th style={{ textAlign: "right", fontSize: 12, padding: 6 }}>
                      Valor a receber
                    </th>
                    <th style={{ textAlign: "right", fontSize: 12, padding: 6 }}>Já recebido</th>
                    <th style={{ textAlign: "right", fontSize: 12, padding: 6 }}>
                      Novo recebimento
                    </th>
                    <th style={{ textAlign: "right", fontSize: 12, padding: 6 }}>
                      Total após registo
                    </th>
                    <th style={{ textAlign: "right", fontSize: 12, padding: 6 }}>Diferença</th>
                  </tr>
                </thead>

                <tbody>
                  {recebimentosLinhas.map((r, idx) => {
                    const valorAReceber = Number(r.valor_a_receber || 0);
                    const valorRecebido = Number(r.valor_total_recebido || 0);
                    const novo = Number(r.novo_recebimento || 0);
                    const totalApos = valorRecebido + novo;
                    const diferenca = valorAReceber - totalApos;

                    return (
                      <tr key={r.id}>
                        <td style={{ fontSize: 12, padding: 6, borderTop: "1px solid #eee" }}>
                          <IconButton
                            size="small"
                            color="info"
                            onClick={() => abrirResultado(r)}
                            title="Detalhe"
                          >
                            <InfoIcon fontSize="small" />
                          </IconButton>
                          {r.faturaorigem}
                        </td>

                        <td
                          style={{
                            fontSize: 12,
                            padding: 6,
                            borderTop: "1px solid #eee",
                            textAlign: "center",
                          }}
                        >
                          <Checkbox
                            checked={!!r.selecionado}
                            onChange={(e) => {
                              const checked = e.target.checked;

                              setRecebimentosLinhas((prev) =>
                                prev.map((x, i) =>
                                  i === idx
                                    ? {
                                        ...x,
                                        selecionado: checked,
                                        novo_recebimento: checked
                                          ? Number(x.valor_em_falta || 0)
                                          : 0,
                                      }
                                    : x
                                )
                              );
                            }}
                            size="small"
                          />
                        </td>

                        <td
                          style={{
                            fontSize: 12,
                            padding: 6,
                            borderTop: "1px solid #eee",
                            textAlign: "right",
                          }}
                        >
                          {valorAReceber.toFixed(3)}
                        </td>

                        <td
                          style={{
                            fontSize: 12,
                            padding: 6,
                            borderTop: "1px solid #eee",
                            textAlign: "right",
                          }}
                        >
                          {valorRecebido.toFixed(3)}
                        </td>

                        <td
                          style={{
                            fontSize: 12,
                            padding: 6,
                            borderTop: "1px solid #eee",
                            textAlign: "right",
                          }}
                        >
                          <input
                            type="number"
                            step="0.001"
                            value={r.novo_recebimento}
                            onChange={(e) => {
                              const value = e.target.value;

                              setRecebimentosLinhas((prev) =>
                                prev.map((x, i) =>
                                  i === idx
                                    ? {
                                        ...x,
                                        novo_recebimento: value,
                                        selecionado: Number(value || 0) !== 0,
                                      }
                                    : x
                                )
                              );
                            }}
                            style={{
                              width: 110,
                              textAlign: "right",
                              padding: 6,
                              borderRadius: 6,
                              border: "1px solid #d2d6da",
                            }}
                          />
                        </td>

                        <td
                          style={{
                            fontSize: 12,
                            padding: 6,
                            borderTop: "1px solid #eee",
                            textAlign: "right",
                          }}
                        >
                          {totalApos.toFixed(3)}
                        </td>

                        <td
                          style={{
                            fontSize: 12,
                            padding: 6,
                            borderTop: "1px solid #eee",
                            textAlign: "right",
                            fontWeight: 600,
                          }}
                        >
                          {diferenca.toFixed(3)}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </MDBox>

            <MDBox mt={2} p={2} sx={{ border: "1px solid #e0e0e0", borderRadius: 2 }}>
              <MDTypography variant="h6" mb={1}>
                Histórico da campanha
              </MDTypography>

              <MDBox sx={{ maxHeight: 220, overflow: "auto" }}>
                <table style={{ width: "100%", borderCollapse: "collapse" }}>
                  <thead>
                    <tr>
                      <th style={{ textAlign: "left", fontSize: 12, padding: 6 }}>Data</th>
                      <th style={{ textAlign: "left", fontSize: 12, padding: 6 }}>Fatura</th>
                      <th style={{ textAlign: "right", fontSize: 12, padding: 6 }}>Valor</th>
                      <th style={{ textAlign: "left", fontSize: 12, padding: 6 }}>Doc/ref.</th>
                      <th style={{ textAlign: "left", fontSize: 12, padding: 6 }}>Obs</th>
                      <th style={{ textAlign: "left", fontSize: 12, padding: 6 }}>Utilizador</th>
                    </tr>
                  </thead>

                  <tbody>
                    {historicoRecebimentosCampanha.map((h) => (
                      <tr key={h.id}>
                        <td style={{ fontSize: 12, padding: 6, borderTop: "1px solid #eee" }}>
                          {h.datarecebimento}
                        </td>
                        <td style={{ fontSize: 12, padding: 6, borderTop: "1px solid #eee" }}>
                          {h.faturaorigem}
                        </td>
                        <td
                          style={{
                            fontSize: 12,
                            padding: 6,
                            borderTop: "1px solid #eee",
                            textAlign: "right",
                          }}
                        >
                          {Number(h.valor_recebido || 0).toFixed(3)}
                        </td>
                        <td style={{ fontSize: 12, padding: 6, borderTop: "1px solid #eee" }}>
                          {h.docref}
                        </td>
                        <td style={{ fontSize: 12, padding: 6, borderTop: "1px solid #eee" }}>
                          {h.obs}
                        </td>
                        <td style={{ fontSize: 12, padding: 6, borderTop: "1px solid #eee" }}>
                          {h.criado_por_nome || h.criado_por}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </MDBox>
            </MDBox>
          </MDBox>
        </DialogContent>

        <DialogActions>
          <MDButton color="secondary" onClick={() => setOpenRecebimentos(false)}>
            Cancelar
          </MDButton>
          <MDButton color="success" onClick={gravarRecebimentos}>
            Gravar recebimentos
          </MDButton>
        </DialogActions>
      </Dialog>

      <Dialog
        PaperComponent={PaperComponent}
        open={openResultadosCampanha}
        onClose={() => setOpenResultadosCampanha(false)}
        maxWidth="lg"
        fullWidth
      >
        <DialogTitle id="draggable-dialog-title" style={{ cursor: "move" }}>
          Resultados detetados {campanhaResultados?.nome ? `— ${campanhaResultados.nome}` : ""}
        </DialogTitle>

        <DialogContent>
          <MDBox sx={{ maxHeight: 520, overflow: "auto", mt: 1 }}>
            <table style={{ width: "100%", borderCollapse: "collapse" }}>
              <thead>
                <tr>
                  <th style={{ textAlign: "left", fontSize: 12, padding: 6 }}>Fatura origem</th>
                  <th style={{ textAlign: "left", fontSize: 12, padding: 6 }}>Cliente</th>
                  <th style={{ textAlign: "left", fontSize: 12, padding: 6 }}>Vendedor</th>
                  <th style={{ textAlign: "right", fontSize: 12, padding: 6 }}>Conjuntos</th>
                  <th style={{ textAlign: "right", fontSize: 12, padding: 6 }}>Valor a receber</th>
                  <th style={{ textAlign: "right", fontSize: 12, padding: 6 }}>Valor recebido</th>
                  <th style={{ textAlign: "left", fontSize: 12, padding: 6 }}>Oferta</th>
                  <th style={{ textAlign: "left", fontSize: 12, padding: 6 }}>Estado</th>
                </tr>
              </thead>

              <tbody>
                {resultados.map((r) => (
                  <tr key={r.id} style={{ cursor: "pointer" }} onClick={() => abrirResultado(r)}>
                    <td style={{ fontSize: 12, padding: 6, borderTop: "1px solid #eee" }}>
                      {r.faturaorigem}
                    </td>
                    <td style={{ fontSize: 12, padding: 6, borderTop: "1px solid #eee" }}>
                      {r.cliente || r.refcliente}
                    </td>
                    <td style={{ fontSize: 12, padding: 6, borderTop: "1px solid #eee" }}>
                      {r.vendedor || r.refvendedor}
                    </td>
                    <td
                      style={{
                        fontSize: 12,
                        padding: 6,
                        borderTop: "1px solid #eee",
                        textAlign: "right",
                      }}
                    >
                      {r.conjuntosdetetados}
                    </td>
                    <td
                      style={{
                        fontSize: 12,
                        padding: 6,
                        borderTop: "1px solid #eee",
                        textAlign: "right",
                      }}
                    >
                      {r.valor_a_receber}
                    </td>
                    <td
                      style={{
                        fontSize: 12,
                        padding: 6,
                        borderTop: "1px solid #eee",
                        textAlign: "right",
                      }}
                    >
                      {r.valor_total_recebido}
                    </td>
                    <td style={{ fontSize: 12, padding: 6, borderTop: "1px solid #eee" }}>
                      {r.refmaterialoferta
                        ? `${r.qtd_oferta_a_receber || ""} ${r.unidadeoferta || ""} ${
                            r.materialoferta || r.refmaterialoferta
                          }`
                        : ""}
                    </td>
                    <td style={{ fontSize: 12, padding: 6, borderTop: "1px solid #eee" }}>
                      {r.estado}

                      {r.estado === "Detetado" && (
                        <MDButton
                          size="small"
                          color="success"
                          style={{ marginLeft: 8 }}
                          onClick={(e) => {
                            e.stopPropagation();
                            pedirValidacaoResultado(r);
                          }}
                        >
                          Validar
                        </MDButton>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </MDBox>
        </DialogContent>

        <DialogActions>
          <MDButton color="info" onClick={() => carregarResultados(campanhaResultados?.id)}>
            Atualizar
          </MDButton>
          <MDButton color="success" onClick={() => abrirRecebimentos(campanhaResultados?.id)}>
            Registar recebimentos
          </MDButton>
          <MDButton color="secondary" onClick={() => setOpenResultadosCampanha(false)}>
            Fechar
          </MDButton>
        </DialogActions>
      </Dialog>

      <Dialog
        PaperComponent={PaperComponent}
        open={openResultado}
        onClose={() => setOpenResultado(false)}
        maxWidth="lg"
        fullWidth
      >
        <DialogTitle id="draggable-dialog-title" style={{ cursor: "move" }}>
          Detalhe do resultado {resultadoSelecionado?.faturaorigem || ""}
        </DialogTitle>

        <DialogContent>
          {resultadoSelecionado && (
            <MDBox display="grid" gap={2} mt={1}>
              <MDBox p={2} sx={{ border: "1px solid #e0e0e0", borderRadius: 2 }}>
                <MDTypography variant="h6" mb={1}>
                  Resumo
                </MDTypography>

                <MDBox display="grid" gridTemplateColumns="1fr 1fr 1fr 1fr" gap={1}>
                  <MDTypography variant="caption">
                    <b>Cliente:</b>{" "}
                    {resultadoSelecionado.cliente || resultadoSelecionado.refcliente}
                  </MDTypography>
                  <MDTypography variant="caption">
                    <b>Vendedor:</b>{" "}
                    {resultadoSelecionado.vendedor || resultadoSelecionado.refvendedor}
                  </MDTypography>
                  <MDTypography variant="caption">
                    <b>Conjuntos:</b> {resultadoSelecionado.conjuntosdetetados}
                  </MDTypography>
                  <MDTypography variant="caption">
                    <b>Estado:</b> {resultadoSelecionado.estado}
                  </MDTypography>
                  <MDTypography variant="caption">
                    <b>Valor a receber:</b> {resultadoSelecionado.valor_a_receber}
                  </MDTypography>
                  <MDTypography variant="caption">
                    <b>Valor recebido:</b> {resultadoSelecionado.valor_total_recebido}
                  </MDTypography>
                  <MDTypography variant="caption">
                    <b>Oferta:</b>{" "}
                    {resultadoSelecionado.refmaterialoferta
                      ? `${resultadoSelecionado.qtd_oferta_a_receber || ""} ${
                          resultadoSelecionado.unidadeoferta || ""
                        } ${
                          resultadoSelecionado.materialoferta ||
                          resultadoSelecionado.refmaterialoferta
                        }`
                      : ""}
                  </MDTypography>
                </MDBox>
              </MDBox>

              <MDBox p={2} sx={{ border: "1px solid #e0e0e0", borderRadius: 2 }}>
                <MDTypography variant="h6" mb={1}>
                  Linhas usadas no cálculo
                </MDTypography>

                <MDBox sx={{ maxHeight: 260, overflow: "auto" }}>
                  <table style={{ width: "100%", borderCollapse: "collapse" }}>
                    <thead>
                      <tr>
                        <th style={{ textAlign: "left", fontSize: 12, padding: 6 }}>Tipo</th>
                        <th style={{ textAlign: "left", fontSize: 12, padding: 6 }}>Fatura</th>
                        <th style={{ textAlign: "left", fontSize: 12, padding: 6 }}>Material</th>
                        <th style={{ textAlign: "left", fontSize: 12, padding: 6 }}>Nome</th>
                        <th style={{ textAlign: "right", fontSize: 12, padding: 6 }}>Qtd usada</th>
                        <th style={{ textAlign: "left", fontSize: 12, padding: 6 }}>Unid.</th>
                      </tr>
                    </thead>

                    <tbody>
                      {resultadoLinhas.map((l) => (
                        <tr key={l.id}>
                          <td style={{ fontSize: 12, padding: 6, borderTop: "1px solid #eee" }}>
                            {l.tipoutilizacao}
                          </td>
                          <td style={{ fontSize: 12, padding: 6, borderTop: "1px solid #eee" }}>
                            {l.faturanumero}
                          </td>
                          <td style={{ fontSize: 12, padding: 6, borderTop: "1px solid #eee" }}>
                            {l.refmaterial}
                          </td>
                          <td style={{ fontSize: 12, padding: 6, borderTop: "1px solid #eee" }}>
                            {l.material}
                          </td>
                          <td
                            style={{
                              fontSize: 12,
                              padding: 6,
                              borderTop: "1px solid #eee",
                              textAlign: "right",
                            }}
                          >
                            {l.qtd}
                          </td>
                          <td style={{ fontSize: 12, padding: 6, borderTop: "1px solid #eee" }}>
                            {l.qtdunid}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </MDBox>
              </MDBox>

              <MDBox p={2} sx={{ border: "1px solid #e0e0e0", borderRadius: 2 }}>
                <MDTypography variant="h6" mb={1}>
                  Benefícios
                </MDTypography>

                <table style={{ width: "100%", borderCollapse: "collapse" }}>
                  <thead>
                    <tr>
                      <th style={{ textAlign: "left", fontSize: 12, padding: 6 }}>Tipo</th>
                      <th style={{ textAlign: "left", fontSize: 12, padding: 6 }}>Base</th>
                      <th style={{ textAlign: "right", fontSize: 12, padding: 6 }}>
                        Valor a receber
                      </th>
                      <th style={{ textAlign: "right", fontSize: 12, padding: 6 }}>
                        Valor recebido
                      </th>
                      <th style={{ textAlign: "left", fontSize: 12, padding: 6 }}>Oferta</th>
                      <th style={{ textAlign: "left", fontSize: 12, padding: 6 }}>Estado</th>
                    </tr>
                  </thead>

                  <tbody>
                    {resultadoBeneficios.map((b) => (
                      <tr key={b.id}>
                        <td style={{ fontSize: 12, padding: 6, borderTop: "1px solid #eee" }}>
                          {b.tipobeneficio}
                        </td>
                        <td style={{ fontSize: 12, padding: 6, borderTop: "1px solid #eee" }}>
                          {b.basecalculo}
                        </td>
                        <td
                          style={{
                            fontSize: 12,
                            padding: 6,
                            borderTop: "1px solid #eee",
                            textAlign: "right",
                          }}
                        >
                          {b.valor_a_receber}
                        </td>
                        <td
                          style={{
                            fontSize: 12,
                            padding: 6,
                            borderTop: "1px solid #eee",
                            textAlign: "right",
                          }}
                        >
                          {b.valor_total_recebido}
                        </td>
                        <td style={{ fontSize: 12, padding: 6, borderTop: "1px solid #eee" }}>
                          {b.refmaterialoferta
                            ? `${b.qtd_oferta_a_receber || ""} ${b.unidadeoferta || ""} ${
                                b.materialoferta || b.refmaterialoferta
                              }`
                            : ""}
                        </td>
                        <td style={{ fontSize: 12, padding: 6, borderTop: "1px solid #eee" }}>
                          {b.estado}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </MDBox>
            </MDBox>
          )}
        </DialogContent>

        <DialogActions>
          <MDButton color="secondary" onClick={() => setOpenResultado(false)}>
            Fechar
          </MDButton>
        </DialogActions>
      </Dialog>
    </DashboardLayout>
  );
}
